import { MALDIVES_BUNDLE_DEFAULT_GUESTS, MALDIVES_BUNDLE_DEFAULT_PRICE_PER_PERSON } from 'constants/charterFlight'
import type { CalendarItemBundleData } from './MaldivesDirectSearchPage/hooks/types'

interface MaldivesBannerPriceDisplay {
  maldivesBundlePrice: number
  isMaldivesBundlePriceLoading: boolean
}

type MaldivesBannerPriceMode = 'total' | 'perPerson'

interface GetMaldivesBannerPriceDisplayParams {
  enabled: boolean
  bannerBundleData: CalendarItemBundleData
  guestCount: number
  priceMode?: MaldivesBannerPriceMode
}

export function getMaldivesBannerPriceDisplay({
  enabled,
  bannerBundleData,
  guestCount,
  priceMode = 'total',
}: GetMaldivesBannerPriceDisplayParams): MaldivesBannerPriceDisplay {
  const defaultPrice = priceMode === 'perPerson'
    ? MALDIVES_BUNDLE_DEFAULT_PRICE_PER_PERSON
    : MALDIVES_BUNDLE_DEFAULT_PRICE_PER_PERSON * (guestCount || MALDIVES_BUNDLE_DEFAULT_GUESTS)

  if (!enabled) {
    return { maldivesBundlePrice: defaultPrice, isMaldivesBundlePriceLoading: false }
  }
  if (bannerBundleData.fetching) {
    return { maldivesBundlePrice: defaultPrice, isMaldivesBundlePriceLoading: true }
  }
  const price = priceMode === 'perPerson'
    ? bannerBundleData.memberPricePerPerson ?? bannerBundleData.pricePerPerson
    : bannerBundleData.memberTotalPrice ?? bannerBundleData.totalPrice
  if (bannerBundleData.available && price > 0) {
    return { maldivesBundlePrice: price, isMaldivesBundlePriceLoading: false }
  }
  return { maldivesBundlePrice: defaultPrice, isMaldivesBundlePriceLoading: false }
}
